import React, { Component } from 'react';
import Section from './Section.js'
import { FormattedHTMLMessage } from 'react-intl';
import SaveStepButton from './SaveStepButton';
import { WAButton } from './Button.js';

class BasicTemplateForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            fields: {}
        };
    }

    render() {

        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)} />
                        {this.props.formattedMessage &&  this.props.formattedDescription && <FormattedHTMLMessage id={this.props.formattedMessage} description={this.props.formattedDescription} />}
                        <div className="show-desktop">
                            <WAButton phone={this.context.intl.formatMessage({
                                id: "app.step_sms_whatsapp_number", defaultMessage: "542612554220"
                            })}
                                text={this.context.intl.formatMessage({
                                    id: "app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"
                                })}
                                value={this.context.intl.formatMessage({
                                    id: "app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"
                                })}
                                gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping" />
                            <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable" />
                            <SaveStepButton />
                        </div>
                    </div>
                    <div className="pd-content-right text-center short-content col-sm-12 col-md-7 col-lg-7">
                        {this.props.children}
                        <div className="show-mobile">
                            <WAButton phone={this.context.intl.formatMessage({
                                id: "app.step_sms_whatsapp_number", defaultMessage: "542612554220"
                            })}
                                text={this.context.intl.formatMessage({
                                    id: "app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"
                                })}
                                value={this.context.intl.formatMessage({
                                    id: "app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"
                                })}
                                gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping" />
                            <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable" />
                            <SaveStepButton />
                        </div>
                    </div>
                </div>
            </Section>
        );
    }

}
BasicTemplateForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

export default BasicTemplateForm;



/** WEBPACK FOOTER **
 ** ./src/components/BasicTemplateForm.js
 **/